<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3592_694)">
      <path
        d="M8 1.16675V15.8334"
        stroke="#4C4C60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 3.83325H6.33333C5.71449 3.83325 5.121 4.07908 4.68342 4.51667C4.24583 4.95425 4 5.54775 4 6.16659C4 6.78542 4.24583 7.37892 4.68342 7.8165C5.121 8.25409 5.71449 8.49992 6.33333 8.49992H9.66667C10.2855 8.49992 10.879 8.74575 11.3166 9.18334C11.7542 9.62092 12 10.2144 12 10.8333C12 11.4521 11.7542 12.0456 11.3166 12.4832C10.879 12.9208 10.2855 13.1666 9.66667 13.1666H4"
        stroke="#4C4C60"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_694">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
